<template>
    <div>

        <div class="panel">
            <div class="panel-body">
                <el-row>
                    <assessment-conf-table></assessment-conf-table>
                </el-row>
            </div>
        </div>

    </div>
</template>

<script type="text/javascript">

    import AssessmentConfTable from './assessmentConfTable'

    let that;


    export default {
        name: 'assessmentConf',

        components: {

            AssessmentConfTable,

        },

        data(){

            return {



            }

        },

        methods: {



        },

        computed: {

        },

        watch: {

        },

        beforeCreate() {
            that = this;
        },

        filters: {



        },

    }

</script>